import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import axios from 'axios'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'

import en_US from './lang/en_US.json'

axios.defaults.baseURL = 'https://api.dev.tattleapp.io/surveys/api/customer-survey/widget/bootstrap'

const LOCALES = {
  en: en_US,
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: LOCALES,
})

const pinia = createPinia()

const app = createApp(App)
app.use(pinia)
app.use(vuetify)
app.use(i18n)

app.mount('#app')
